import React from 'react'
import { about, about1, about2, about3, blogs1, blogs2, blogs3, product1, product2, product3, product4 } from '../../assets/images';
import { useTranslation } from 'react-i18next';


const Others = () => {

  const { t, i18n } = useTranslation();
  return (
      <div className="md:max-w-container max-w-containerSm mx-auto mt-[40px] md:mt-[88px]">
    <p className="text-[22px] md:text-[28px] font-semibold text-center mb-10">{t("Digər bloqlar")}</p>
    <div className="block md:flex justify-between mx-auto md:mx-0">
        {/* Category 1 */}
        <div className="relative md:w-[421px] md:h-[369px] mb-5 md:mb-0">
          <img src={blogs1} alt="Category 1" className="w-full md:h-[336px] object-cover rounded-xl" />
          <p className='mt-4'>Lorem ipsum amet, consectetur adipiscing elit...</p>
        </div>
        {/* Category 2 */}
        <div className="relative md:w-[421px] md:h-[369px] mb-5 md:mb-0">
          <img src={blogs2} alt="Category 2" className="w-full md:h-[336px] object-cover rounded-xl" />
          <p className='mt-4'>Lorem ipsum amet, consectetur adipiscing elit...</p>
        </div>
        {/* Category 3 */}
        <div className="relative md:w-[421px] md:h-[369px]">
          <img src={blogs3} alt="Category 3" className="w-full md:h-[336px] object-cover rounded-xl" />
          <p className='mt-4'>Lorem ipsum amet, consectetur adipiscing elit...</p>
        </div>
      </div>
  </div>
  )
}

export default Others